export const GET_APP_PREFERENCES_STARTED = 'GET_APP_PREFERENCES_STARTED'
export const GET_APP_PREFERENCES_ERROR = 'GET_APP_PREFERENCES_ERROR'
export const GET_APP_PREFERENCES_SUCCESS = 'GET_APP_PREFERENCES_SUCCESS'
